var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentSuitcaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1557_21840)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1557_21840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0051 5.02161C18.004 5.02161 18.003 5.02148 18.002 5.02148H13.4863V4.52344C13.4863 3.69958 12.816 3.0293 11.9922 3.0293H8.00781C7.18396 3.0293 6.51367 3.69958 6.51367 4.52344V5.02148H1.99805C1.72075 5.02148 1.5 5.24872 1.5 5.51953V16.4766C1.5 17.3004 2.17029 17.9707 2.99414 17.9707H17.0059C17.8297 17.9707 18.5 17.3004 18.5 16.4766V5.53004C18.5 5.52939 18.5 5.52874 18.5 5.52809C18.4809 5.20099 18.2798 5.02343 18.0051 5.02161ZM7.50977 4.52344C7.50977 4.24886 7.73324 4.02539 8.00781 4.02539H11.9922C12.2668 4.02539 12.4902 4.24886 12.4902 4.52344V5.02148H7.50977V4.52344ZM17.3109 6.01758L15.7642 10.6575C15.6964 10.8612 15.5065 10.998 15.2919 10.998H12.4902V10.5C12.4902 10.2249 12.2673 10.002 11.9922 10.002H8.00781C7.73272 10.002 7.50977 10.2249 7.50977 10.5V10.998H4.70812C4.49347 10.998 4.30359 10.8612 4.23576 10.6575L2.68909 6.01758H17.3109ZM11.4941 10.998V11.9941H8.50586V10.998H11.4941ZM17.5039 16.4766C17.5039 16.7511 17.2804 16.9746 17.0059 16.9746H2.99414C2.71957 16.9746 2.49609 16.7511 2.49609 16.4766V8.58862L3.29076 10.9725C3.49439 11.5836 4.06403 11.9941 4.70812 11.9941H7.50977V12.4922C7.50977 12.7673 7.73272 12.9902 8.00781 12.9902H11.9922C12.2673 12.9902 12.4902 12.7673 12.4902 12.4922V11.9941H15.2919C15.936 11.9941 16.5056 11.5836 16.7092 10.9725L17.5039 8.58862V16.4766Z",
    fill: "#494949",
    fillOpacity: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1557_21840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1557_21840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(1.5 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentSuitcaseIcon);
export default __webpack_public_path__ + "static/media/student_suitcase_icon.cb7af16a39d2888190899f2b7d9893c6.svg";
export { ForwardRef as ReactComponent };